export const Error = () => {
    return (
        <>
            <h1 style={{
                textAlign: "center",
                marginTop: "40px"
            }}>Page not found</h1>
        </>
    )
}